import { createFileRoute } from '@tanstack/react-router';
import { msg } from '@lingui/core/macro';

/**
 * Layout route for the `/users` family. Renders the default `<Outlet />`; its
 * label makes "Users" an ancestor breadcrumb (and document-title fallback) on
 * every `/users/*` page.
 */
export const Route = createFileRoute('/_logged/users')({
  staticData: { label: msg`Users` },
});
